import mixins from '@/mixins';

export default {
  name: 'PrivacyPolicy',

  mixins: [mixins],

  data() {
    return {}
  },
}
